/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/**
 * A React component for managing notices.
 * @returns The NoticeManagement component.
 */
import React, { useEffect, useRef, useState } from "react";
import Select, { components } from "react-select";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _, { debounce } from "lodash";
import moment from "moment";
import { saveAs } from "file-saver";
import useWindowDimension from "../../components/hooks/useWindowDimension";
import { showToast } from "../../store/toast/actions";
// import "./noticeManagementNew.scss";
import { getNoticeList, getNoticeTotals } from "../../store/noticeManagement/actions";
import Constant from "../../util/constant";
import { Helmet } from "react-helmet";
import NoticeManagementNewComponent from "./noticeManagementNewComponent";
import { getDepotsList } from "../../store/depots/actions";
import { getNoticeTypeList } from "../../store/noticeType/actions";
import Calender from "../../components/datePicker/datePicker";
/**
 * A container component for managing notices.
 * @param {{props}} props - The component props.
 * @returns The NoticeManagementContainer component.
 */
/**
 * Container component for managing notices.
 * @param {{props}} props - The props passed to the component.
 * @returns The rendered component.
 */
const NoticeManagementNewContainer = ({ props }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const itemData = searchParams.get("itemData");
  const itemNotice = itemData ? JSON.parse(decodeURIComponent(itemData)) : null;
  const noticeList = useSelector(
    (state) => state?.noticeManagement?.noticeList?.data?.data
  );
  const pagination = useSelector(
    (state) => state?.noticeManagement?.noticeList?.data?.pagination
  );

  const totalCounts = useSelector(
    (state) => state?.noticeManagement?.noticeTotals
  );
  const depotList = useSelector((state) => state?.Depots?.depotsList?.data);
  const noticeTypeList = useSelector(
    (state) => state?.NoticeType?.noticeList?.data
  );
  // custom listing
  const [noticeListState, setnoticeListState] = useState([]);
  const [sortTrigger, setsortTrigger] = useState({});

  useEffect(() => {
    // console.log(noticeListState, "noticeListState");
  }, [noticeListState]);

  // custom sorting
  // useEffect(() => {
  //   console.log(sortTrigger, 'sortTrigger');
  //   if (noticeListState.length > 0) {
  //     setnoticeListState(prev => {
  //       console.log('prev', prev);
  //       const newstate = prev.sort((a, b) => {
  //         if (a.noticetypename[0].noticetypename < b.noticetypename[0].noticetypename) { return sortTrigger?.state == 'asc' ? 1 : -1; }
  //         if (a.noticetypename[0].noticetypename > b.noticetypename[0].noticetypename) { return sortTrigger?.state == 'asc' ? -1 : 1; }
  //         return 0;
  //       })
  //       return newstate
  //     })
  //   }
  // }, [sortTrigger])

  const smarttableref = useRef();
  const dimensions = useWindowDimension();
  const pageSizeRef = useRef(dimensions.width > 1920 ? 25 : 10);
  const navigate = useNavigate();
  const tableContainerRef = useRef(null);

  /**
   * Initializes state variables for loading, placeholder, table filter height, breadcrumb height,
   * tab header height, loader HTML height, and header height.
   * @returns None
   */

  const [checkNoticeData, setCheckNoticeData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [placeHolder, setPlaceHolder] = useState(true);
  const [isRequestPending, setIsRequestPending] = useState(false); // Track if API request is in flight
  const [tableFilterHeight, setTableFilterHeight] = useState("");
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [tabHeaderHeight, setTabHeaderHeight] = useState("");
  const [loaderHtml, setLoaderHtmlHeight] = useState("");
  const [headerHeight, setHeaderHeight] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [searchValue, setSearchValue] = useState(null);
  const [searchInputValue, setSearchInputValue] = useState(''); // Local state for immediate input feedback
  const debouncedSetSearchValueRef = useRef(null);
  const requestInFlightRef = useRef(false); // Prevent duplicate requests
  const [exportCsvData, setexportCsvData] = useState([]);
  const [depotMultiSelectarray, setDepotMultiSelectarray] = useState([]);
  const [noticetypemultiarray, setNoticetypemultiarray] = useState([]);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const [sortOrder, setSortOrder] = useState("default");
  const [totalsLoading, setTotalsLoading] = useState(false);

  useEffect(() => {
    // Only update state if we have actual data (not empty array from 204 response)
    // Don't update to empty array if we're still loading or have a pending request
    if (noticeList !== undefined && Array.isArray(noticeList)) {
      if (noticeList.length > 0) {
        setnoticeListState(
          noticeList.map((itm) => { 
            return {
              ...itm,
              noticetype: itm?.noticetypename[0]?.noticetypename,
            };
          })
        );
        setIsRequestPending(false); // Request completed with data
      } else if (!placeHolder && !isRequestPending) {
        // Only set empty array if we're not loading AND no request is pending
        setnoticeListState([]);
      }
    }
  }, [noticeList, placeHolder, isRequestPending]);

  const handleSort = () => {
    let newSortOrder;
    if (sortOrder === "default") {
      newSortOrder = "asc";
    } else if (sortOrder === "asc") {
      newSortOrder = "desc";
    } else {
      newSortOrder = "default";
    }

    setSortOrder(newSortOrder);

    let queryParams = { page : currentPage, limit : itemsPerPage, sortOrder: newSortOrder };

    // const searchValue = localStorage.getItem("searchValue");
    if(searchValue){
      queryParams.search = searchValue
    }

    const noticeTypeFilter = localStorage.getItem("noticeTypeFilter");
    const noticeTypeFilterObject = noticeTypeFilter ? JSON.parse(noticeTypeFilter) : null;
    if(noticeTypeFilterObject){
      queryParams.noticetypeid = noticeTypeFilterObject?.map(i => i.id)
    }

    const depotFilter = localStorage.getItem("depotFilter");
    const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
    if(depotFilterObject){
      queryParams.depotid = depotFilterObject?.map(i => i.id)
    }

    if (startDate && endDate){
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }
    
    setPlaceHolder(true);
    
    dispatch(
      getNoticeList(queryParams, (res) => {
        setPlaceHolder(false); 
      }, (err) => {
        // Error callback - stop loader on API failure
        setPlaceHolder(false);
        console.error('Failed to load notices:', err);
      })
    );
    getTotals();

    // sorterCallback("title", newSortOrder);
  };

  const getSortIcon = () => {
    if (sortOrder === "asc") return "fas fa-sort-up"; // Ascending
    if (sortOrder === "desc") return "fas fa-sort-down"; // Descending
    return "fas fa-sort"; // Default
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // const totalItems = noticeListState?.pagination?.total || 0;
  const [totalPages, setTotalPages] = useState(1);
  // const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [noticeTypeFilterList, setNoticeTypeFilterList] = useState();
  const [depotFilterList, setDepotFilterList] = useState();
  // const [searchValue, setSearchValue] = useState("");
  const itemsPerPageOptions = [5, 10, 15, 20];
  const customheaderkeys = [
    Constant.NOTICEMANAGEMENTEXPORTKEY.TITLE,
    Constant.NOTICEMANAGEMENTEXPORTKEY.SUBTITLE,
    Constant.NOTICEMANAGEMENTEXPORTKEY.NOTICETYPENAME,
    Constant.NOTICEMANAGEMENTEXPORTKEY.DEPOTNAME,
    Constant.NOTICEMANAGEMENTEXPORTKEY.EXPIRYDATETIME,
    "notOpened",
    "openedBy",
    "downloadedBy",
    "signedBy",
    Constant.NOTICEMANAGEMENTEXPORTKEY.DOCUMENTURL,
  ];

  const [searchVal, setSearchVal] = useState('');
  const validityFilter = localStorage.getItem("validityFilter");
  const validityArray = validityFilter ? JSON.parse(validityFilter) : null;
  const [startDate, setStartDate] = useState(validityArray?.[0]);
  const [endDate, setEndDate] = useState(validityArray?.[1]);
  const [dateFilterChange, setDateFilterChange] = useState(false);

  /**
   * Executes a side effect after the component has rendered.
   * The side effect sets the `placeHolder` state to `false` after a delay of 2000 milliseconds.
   * @returns None
   */
  // useEffect(() => {
  //   getList();
  // }, []);

  // Initialize debounced search function
  useEffect(() => {
    debouncedSetSearchValueRef.current = debounce((value) => {
      setSearchValue(value || null);
      setCurrentPage(1);
    }, 500);

    return () => {
      if (debouncedSetSearchValueRef.current) {
        debouncedSetSearchValueRef.current.cancel();
      }
    };
  }, []);

  useEffect(() => {
    getList();
    getTotals();
  }, [dispatch, location.pathname, dateFilterChange]);

  /**
   * Fetches notice totals separately from the notice list
   * @param {string|null} searchValueOverride - Optional search value to use instead of state value
   * @returns None
   */
  const getTotals = (searchValueOverride = undefined) => {
    let queryParams = {};

    const currentSearchValue = searchValueOverride !== undefined ? searchValueOverride : searchValue;
    if(currentSearchValue){
      queryParams.search = currentSearchValue
    }

    const noticeTypeFilter = localStorage.getItem("noticeTypeFilter");
    const noticeTypeFilterObject = noticeTypeFilter ? JSON.parse(noticeTypeFilter) : null;
    if(noticeTypeFilterObject){
      queryParams.noticetypeid = noticeTypeFilterObject?.map(i => i.id)
    }

    const depotFilter = localStorage.getItem("depotFilter");
    const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
    if(depotFilterObject){
      queryParams.depotid = depotFilterObject?.map(i => i.id)
    }

    if (startDate && endDate){
      queryParams.startDate = moment(startDate).startOf('day');
      queryParams.endDate = moment(endDate).endOf('day');
    }

    setTotalsLoading(true);
    dispatch(
      getNoticeTotals(queryParams, (res) => {
        setTotalsLoading(false);
      }, (err) => {
        setTotalsLoading(false);
        console.error('Failed to load notice totals:', err);
      })
    );
  };


  // useEffect(() => {
  //   if (startDate && endDate) {
  //     getList();
  //   }
  // }, [startDate, endDate]);
  


  /**
   * Retrieves the notice list by dispatching the 'getNoticeList' action.
   * Sets the placeholder to false and logs the response.
   * @returns None
   */
  const getList = async () => {
    // Prevent duplicate requests
    if (requestInFlightRef.current) {
      return;
    }

    let queryParams = { page : 1, limit : itemsPerPage, sortOrder: sortOrder };

    if(searchValue){
      queryParams.search = searchValue
    }

    const noticeTypeFilter = localStorage.getItem("noticeTypeFilter");
    const noticeTypeFilterObject = noticeTypeFilter ? JSON.parse(noticeTypeFilter) : null;
    if(noticeTypeFilterObject){
      queryParams.noticetypeid = noticeTypeFilterObject?.map(i => i.id)
    }

    const depotFilter = localStorage.getItem("depotFilter");
    const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
    if(depotFilterObject){
      queryParams.depotid = depotFilterObject?.map(i => i.id)
    }

    if (startDate && endDate){
      queryParams.startDate = moment(startDate).startOf('day');
      queryParams.endDate = moment(endDate).endOf('day');
    }
    
    setPlaceHolder(true);
    setIsRequestPending(true); // Mark request as pending
    requestInFlightRef.current = true; // Mark request as in flight

    dispatch(
      getNoticeList(queryParams, (res) => {
          requestInFlightRef.current = false; // Request completed
          
          // Only stop loader if we got actual data (not empty/204 response)
          // Check if response has data array with items, or if response structure indicates real data
          const hasData = res && (
            (Array.isArray(res?.data?.data) && res.data.data.length > 0) ||
            (Array.isArray(res?.data) && res.data.length > 0) ||
            (res?.data && typeof res.data === 'object' && Object.keys(res.data).length > 0)
          );
          
          if (hasData) {
            setPlaceHolder(false);
            setIsRequestPending(false); // Request completed with data
          } else {
            // Empty/204 response - keep loader running, but mark request as completed
            // This allows the next request to start fresh
            setIsRequestPending(false);
            // Don't set placeHolder to false here - let it stay true for the next request
          }
      }, (err) => {
          requestInFlightRef.current = false; // Request completed (with error)
          // Error callback - stop loader on API failure
          setPlaceHolder(false);
          setIsRequestPending(false); // Request completed (with error)
          console.error('Failed to load notices:', err);
      })
    );

    // queryParams.status = Constant.GENERALKEYS.ACTIVE;
    dispatch(
      getDepotsList(
        {},
        (res) => { },
        (err) => { }
      )
    );

    dispatch(
      getNoticeTypeList(
        {},
        (res) => { },
        (err) => { }
      )
    );
  };

  // console.log("itemsPerPage", itemsPerPage);

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));

    let queryParams = { page : 1, limit : Number(event.target.value), sortOrder: sortOrder };

    // const searchValue = localStorage.getItem("searchValue");
    if(searchValue){
      queryParams.search = searchValue
    }

    const noticeTypeFilter = localStorage.getItem("noticeTypeFilter");
    const noticeTypeFilterObject = noticeTypeFilter ? JSON.parse(noticeTypeFilter) : null;
    if(noticeTypeFilterObject){
      queryParams.noticetypeid = noticeTypeFilterObject?.map(i => i.id)
    }

    const depotFilter = localStorage.getItem("depotFilter");
    const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
    if(depotFilterObject){
      queryParams.depotid = depotFilterObject?.map(i => i.id)
    }

    if (startDate && endDate){
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }

    setPlaceHolder(true);

    dispatch(
      getNoticeList(queryParams, (res) => {
        setPlaceHolder(false); 
      })
    );

    setCurrentPage(1);
  };
  const handlePageClick = (page) => {
    setCurrentPage(page);

    let queryParams = { page : page, limit : itemsPerPage, sortOrder: sortOrder };

    // const searchValue = localStorage.getItem("searchValue");
    if(searchValue){
      queryParams.search = searchValue
    }

    const noticeTypeFilter = localStorage.getItem("noticeTypeFilter");
    const noticeTypeFilterObject = noticeTypeFilter ? JSON.parse(noticeTypeFilter) : null;
    if(noticeTypeFilterObject){
      queryParams.noticetypeid = noticeTypeFilterObject?.map(i => i.id)
    }

    const depotFilter = localStorage.getItem("depotFilter");
    const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
    if(depotFilterObject){
      queryParams.depotid = depotFilterObject?.map(i => i.id)
    }

    if (startDate && endDate){
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }

    setPlaceHolder(true);

    dispatch(
      getNoticeList(queryParams, (res) => {
        setPlaceHolder(false); 
      })
    );
  };

  useEffect(() => {
// console.log("noticeListState",noticeListState);

    setTotalPages(pagination?.totalPages)
    // console.log("Total pages", totalPages);
    
  }, [pagination])

  /**
   * Loads more items when triggered, with a delay of 2000 milliseconds.
   * @returns None
   */
  const loadMoreItems = () => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      pageSizeRef.current += 10;
    }, 2000);
  };

  /**
   * Debounces the handleTableScroll function to prevent it from being called too frequently.
   * When the table container is scrolled, it checks if the scroll position is at the bottom
   * and if there are more items to load. If both conditions are met, it calls the loadMoreItems function.
   * @returns None
   */
  const handleTableScroll = debounce(() => {
    const tableContainer = tableContainerRef?.current;
    if (tableContainer) {
      const isAtBottom =
        tableContainer?.scrollTop + tableContainer?.clientHeight >=
        tableContainer.scrollHeight;
      if (isAtBottom && noticeList?.length > pageSizeRef?.current) {
        loadMoreItems();
      }
    }
  }, 200);

  /**
   * Adds an event listener to the table container element to handle scroll events.
   * The event listener is removed when the component is unmounted.
   * @param {{function}} handleTableScroll - The function to handle the table scroll event.
   * @returns None
   */
  useEffect(() => {
    const tableContainer = tableContainerRef?.current;
    if (tableContainer) {
      tableContainer.addEventListener("scroll", handleTableScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleTableScroll);
      }
    };
  }, [handleTableScroll]);

  /**
   * useEffect hook that sets various heights based on the elements in the DOM.
   * @param {{boolean}} loading - Indicates whether the page is currently loading.
   * @returns None
   */
  useEffect(() => {
    loading &&
      setLoaderHtmlHeight(
        document.getElementsByClassName("infinate-load")[0]?.offsetHeight
      );
    setHeaderHeight(
      document.getElementsByClassName("navbar-header")[0]?.offsetHeight
    );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0]?.offsetHeight
    );
    setTableFilterHeight(
      document.getElementsByClassName("FormButton_Wrapper")[0]?.offsetHeight
    );
    setTabHeaderHeight(document.getElementsByTagName("thead")[0]?.offsetHeight);
  }, [loading]);

  /**
   * Adds a resize event listener to the window and updates the window width state
   * whenever the window is resized. Removes the event listener when the component is unmounted.
   * @returns None
   */
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /**
   * An array of column objects used for rendering a table.
   * Each column object represents a column in the table and contains properties such as label, key, filter, and sorting.
   * @returns {Array} - An array of column objects.
   */

  const startdateFilterDate = new Date(startDate);
  const startdateFilterFormat = "YYYY-MM-DD";
  const currentstartdateformattedDate = moment(startdateFilterDate).format(
    startdateFilterFormat
  );


  /**
   * Clears the search input by programmatically clicking the clear button.
   * @returns None
   */
  const clearSearchButton = () => {
    smarttableref.current.querySelectorAll("button")[0].click();
  };

  /**
   * Function to simulate a delayed document download and display a success toast message.
   * @returns None
   */
  const documentDownLoadFun = (item) => {
    const s3ObjectKey = item?.documenturl;
    const s3BucketUrl = process.env.REACT_APP_AWS_UPLOAD_DOCUMENT_URL;
    const documentUrl = `${s3BucketUrl}${encodeURIComponent(s3ObjectKey)}`;
    saveAs(documentUrl, s3ObjectKey);

    setTimeout(() => {
      dispatch(
        showToast({
          message: t("DOWNLOADED_SUCCESSFULLY"),
          type: "success",
        })
      );
    }, 1000);
  };

  /**
   * Handles the click event on a row in the notice management table.
   * Navigates to the notice details page with the selected item as the state.
   * @param {{any}} item - The selected item from the table row.
   * @returns None
   */
  const onRowClick = (item) => {
    navigate("/noticemanagement/noticeDetails", {
      state: {
        item,
      },
    });
  };

  const exportNotice = () => {
    setTimeout(() => {
      dispatch(
        showToast({
          message: t("NOTICE_HAS_BEEN_EXPORTED_SUCCESSFULLY"),
          type: "success",
        })
      );
    }, 1000);
  };

  const createNotice = (item) => {
    navigate("/noticemanagement/createnotice", {
      state: {
        item,
      },
    });
  };

  const onTableFilterChange = (filterText) => {
    setSearchValue(filterText);
    // if (filterText) {
    //   localStorage.setItem("searchValue", filterText)
    // } else {
    //   localStorage.removeItem("searchValue")
    // }
  };
  const searchFilterClear = () => {
    smarttableref.current.querySelectorAll("button")[1].click();
  };
  /**
   * useEffect hook that updates the exportCsvData state variable whenever the noticeList
   * prop changes.
   * @param {{Array}} noticeList - The list of notices to export as CSV.
   * @returns None
   */
  useEffect(() => {
    if (noticeList !== undefined && noticeList?.length > 0) {
      // console.log(
      //   "this2:===>",
      //   noticeList.map((item) => {
      //     return customheaderkeys.map((i) => {
      //       // console.log("item:===>", i, item[i]);
      //       if (item[i] == null && i == "documenturl") {
      //         return item.noticelink;
      //       } else if (item[i] == undefined) {
      //         return "-";
      //       } else if (
      //         i == "open" ||
      //         i == "notopen" ||
      //         i == "signed" ||
      //         i == "downloaded"
      //       ) {
      //         return item[i];
      //       } else if (moment(item[i]).isValid() && i == "expirydatetime") {
      //         return moment(item[i]).format("DD-MM-YYYY h:mm A ");
      //       } else if (item[i] == null && i == "documenturl") {
      //         return item.noticelink;
      //       } else if (Array.isArray(item[i])) {
      //         return item[i].map((intI) => intI[i]).join(", ");
      //       } else {
      //         return item[i];
      //       }
      //     });
      //   })
      // );
      setexportCsvData(
        noticeList.map((item) => {
          return customheaderkeys.map((i) => {
            
            if (i === "documenturl" && item[i] == null) {
              return item.noticelink;
            }
            if (item[i] === undefined) {
              return "-";
            }
            if (i === "openedBy") {
              return item?.openedBy?.length;
            }
            if (i === "notOpened") {
              return item.notOpened;
            }
            if (i === "signedBy") {
              return item?.signedBy?.length;
            }
            if (i === "downloadedBy") {
              return item?.downloadedBy?.length;
            }
            if (i === "expirydatetime" && moment(item[i]).isValid()) {
              return moment(item[i]).format("DD-MM-YYYY h:mm A");
            }
            if (Array.isArray(item[i])) {
              return item[i].length > 0 ? item[i].map((intI) => intI[i]).join(", ") : "-";
            }
            if (i === "noticetypename" && item[i] === "") {
              return "-";
            }
            return item[i];
          });
        })
      );
      
    }
    
  }, [noticeList]);

  useEffect(() => {
    // console.log("exportCsvData===:>", exportCsvData);
  }, [exportCsvData]);




  
  const onFilteredItemsChange = (data) => {
    // console.log("Received data:", data);
    
    if (!Array.isArray(data)) {
      console.error("onFilteredItemsChange expects an array but received:", data);
      return;
    }
  
    if (data.length > 0) {
      console.log(`var ----->>>>11`);
      setCheckNoticeData(true);
    } else {
      console.log(`var ----->>>>`);
      setCheckNoticeData(false);
    }
  
    console.log("dataOne", data);
  
    if (data !== undefined) {
      console.log("customheaderkeys:===>", customheaderkeys);
  
      const processedData = data.map((item) => {
        return customheaderkeys.map((i) => {
          console.log("item:===>", i, item[i]);
  
          if (item[i] == null && i == "documenturl") {
            return item.noticelink;
          } else if (item[i] == undefined) {
            return "-";
          } else if (["open", "notopen", "signed", "downloaded"].includes(i)) {
            return item[i];
          } else if (moment(item[i]).isValid() && i == "expirydatetime") {
            return moment(item[i]).format("DD-MM-YYYY h:mm A ");
          } else if (Array.isArray(item[i])) {
            return item[i].length > 0 ? item[i].map((intI) => intI[i]).join(", ") : "-";
          } else if (item[i] == "" && i == "noticetypename") {
            return "-";
          } else {
            return item[i];
          }
        });
      });
  
      // setexportCsvData(processedData);
    }
  };

  const onDepotFilteredItemsChange = (data) => {
    console.log("Received data:", data);
    
    if (!Array.isArray(data)) {
      console.error("onFilteredItemsChange expects an array but received:", data);
      return;
    }
  
    if (data.length > 0) {
      console.log(`var ----->>>>11`);
      setCheckNoticeData(true);
    } else {
      console.log(`var ----->>>>`);
      setCheckNoticeData(false);
    }
  
    console.log("dataOne", data);
  
    if (data !== undefined) {
      console.log("customheaderkeys:===>", customheaderkeys);
  
      const processedData = data.map((item) => {
        return customheaderkeys.map((i) => {
          console.log("item:===>", i, item[i]);
  
          if (item[i] == null && i == "documenturl") {
            return item.noticelink;
          } else if (item[i] == undefined) {
            return "-";
          } else if (["open", "notopen", "signed", "downloaded"].includes(i)) {
            return item[i];
          } else if (moment(item[i]).isValid() && i == "expirydatetime") {
            return moment(item[i]).format("DD-MM-YYYY h:mm A ");
          } else if (Array.isArray(item[i])) {
            return item[i].length > 0 ? item[i].map((intI) => intI[i]).join(", ") : "-";
          } else if (item[i] == "" && i == "noticetypename") {
            return "-";
          } else {
            return item[i];
          }
        });
      });
  
      // setexportCsvData(processedData);
    }
  };
  
  const noticeTypeFilter = (values, onChange) => {
    const unique = [...new Set(values)].sort();
    const _noticeOptions = unique?.map((elementdepot) =>
      elementdepot?.map((item) => ({
        label: item?.noticetypename,
        value: item?.noticetypename,
      }))
    );
    let finalarr = [];  
    const options = noticeTypeList?.map((item) => {
      return { id: item.noticetypeid, label: item?.name, value: item?.name }
    });;
    const noticeOption = _noticeOptions?.flatMap((item) => item);
    noticeOption?.forEach((item) => {
      let options = finalarr?.map((i) => i.label);
      if (!options?.includes(item?.label)) {
        finalarr.push(item);
      }
    });

    const handleChange = (selected) => {
      let queryParams = { page : 1, limit : itemsPerPage, sortOrder: sortOrder };
      setCurrentPage(1);
      // const searchValue = localStorage.getItem("searchValue");
      if(searchValue){
        queryParams.search = searchValue
      }

      const depotFilter = localStorage.getItem("depotFilter");
      const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
      if(depotFilterObject){
        queryParams.depotid = depotFilterObject?.map(i => i.id)
      }

      if (startDate && endDate){
        queryParams.startDate = startDate;
        queryParams.endDate = endDate;
      }

      if (selected.length > 0) {
        localStorage.setItem("noticeTypeFilter", JSON.stringify(selected));
        const selectedNoticeTypeIdList = selected.map(i => i.id)
        setNoticeTypeFilterList(selectedNoticeTypeIdList);
        queryParams.noticetypeid = selectedNoticeTypeIdList
      } else {
        localStorage.removeItem("noticeTypeFilter");
      }
      
      setPlaceHolder(true);

      dispatch(
        getNoticeList(queryParams, (res) => {
          setPlaceHolder(false);
        })
      );
      getTotals();

      setNoticetypemultiarray(selected);

      // Note: onChange callback removed - filtering is now handled server-side via API
      // The onFilteredItemsChange expects an array, not a filter function
    };

    const CustomOption = ({ children, ...props }) => {
      return (
        <components.Option {...props}>
          <input type="checkbox" checked={props.isSelected} onChange={() => {}}/>
          <label htmlFor="checkbox">
            <span></span>
          </label>
          {children}
        </components.Option>
      );
    };

    return (
      <div
        className={
          noticetypemultiarray?.length > 1
            ? "multipleselectWrapper customeSelectWrapper"
            : "customeSelectWrapper"
        }
      >
        <Select
          closeMenuOnSelect={false}
          isMulti
          onChange={handleChange}
          options={options}
          hideSelectedOptions={false}
          components={{ Option: CustomOption }}
          placeholder={t("SELECT")}
          className="react-select-container multiSelecter"
          classNamePrefix="react-select"
          defaultValue={
            localStorage.getItem("noticeTypeFilter")
              ? JSON.parse(localStorage.getItem("noticeTypeFilter"))
              : undefined
          }
        />
        {noticetypemultiarray?.length > 1 && (
          <p className="multiselectTag">
            +{noticetypemultiarray?.slice(1)?.length}
          </p>
        )}
      </div>
    );
  };

  const depotTypeFilter = (values, onChange) => {
    // const options = [
    //   { id: 1, label: "Wick Drivers", value: "Wick Drivers" },
    //   { id: 2, label: "Corkerhill Depot Drivers", value: "Corkerhill Depot Drivers" },
    //   { id: 3, label: "Ayr Drivers", value: "Ayr Drivers" },
    //   { id: 4, label: "xDesign", value: "xDesign" },
    //   { id: 5, label: "Aberdeen Conductors", value: "Aberdeen Conductors" },
    // ];

    // console.log("depotList ", depotList);
    
    const options = depotList?.map((item) => {
      return { id: item.depotid, label: item?.name, value: item?.name }
    });;
    const handleChange = (selected) => {
      let queryParams = { page : 1, limit : itemsPerPage, sortOrder: sortOrder };
      setCurrentPage(1);
      // const searchValue = localStorage.getItem("searchValue");
      if(searchValue){
        queryParams.search = searchValue
      }

      const noticeTypeFilter = localStorage.getItem("noticeTypeFilter");
      const noticeTypeObject = noticeTypeFilter ? JSON.parse(noticeTypeFilter) : null;
      if(noticeTypeObject){
        queryParams.noticetypeid = noticeTypeObject?.map(i => i.id)
      }

      if (startDate && endDate){
        queryParams.startDate = startDate;
        queryParams.endDate = endDate;
      }

      if (selected.length > 0) {
        localStorage.setItem("depotFilter", JSON.stringify(selected));
        const selcetedDepotTypeIdList = selected.map(i => i.id)
        setDepotFilterList(selcetedDepotTypeIdList);
        queryParams.depotid = selcetedDepotTypeIdList
      } else {
        localStorage.removeItem("depotFilter");
      }

      setPlaceHolder(true);

      dispatch(
        getNoticeList(queryParams, (res) => {
          setPlaceHolder(false);
        })
      );
      getTotals();

      setDepotMultiSelectarray(selected);
      
      // Note: onChange callback removed - filtering is now handled server-side via API
      // The onDepotFilteredItemsChange expects an array, not a filter function
    };

    const CustomOption = ({ children, ...props }) => {
      return (
        <components.Option {...props}>
          <input type="checkbox" checked={props.isSelected} onChange={() => {}}/>
          <label htmlFor="checkbox">
            <span></span>
          </label>
          {children}
        </components.Option>
      );
    };

    return (
      <div
        className={
          depotMultiSelectarray?.length > 1
            ? "multipleselectWrapper customeSelectWrapper"
            : "customeSelectWrapper"
        }
      >
        <Select
          closeMenuOnSelect={false}
          isMulti
          onChange={handleChange}
          options={options}
          hideSelectedOptions={false}
          components={{ Option: CustomOption }}
          placeholder={t("SELECT")}
          className="react-select-container multiSelecter"
          classNamePrefix="react-select"
          defaultValue={
            localStorage.getItem("depotFilter")
              ? JSON.parse(localStorage.getItem("depotFilter"))
              : undefined
          }
        />
        {depotMultiSelectarray?.length > 1 && (
          <p className="multiselectTag">
            +{depotMultiSelectarray?.slice(1)?.length}
          </p>
        )}
      </div>
    );
  };
  const [dateRangeError, setDateRangeError] = useState(false);
  const handleDateFilterChange = (dates) => {
    const [start, end] = dates;
    localStorage.setItem('validityFilter', JSON.stringify(dates))
    let newStartDate = null;
    let newEndDate = null;

    if (start) {
      newStartDate = moment(start).isValid() ? moment(start).startOf('day') : null;
    }
    if (end) {
      newEndDate = moment(end).isValid() ? moment(end).endOf('day') : null;
    }

    setStartDate(newStartDate);
    setEndDate(newEndDate);

    if ((start && end) || (!start && !end)) {
      setDateFilterChange(prev => !prev)
    }

    // Set error state based on date selection
    // If a start date is selected but no end date, set error to true
    if (newStartDate && !newEndDate) {
      setDateRangeError(true);
    } else {
      setDateRangeError(false);
    }
  };
  // console.log("start date: " + startDate + " end: " + endDate);

  const toggleDatePicker = () => {
    setIsDatePickerOpen(!isDatePickerOpen);
  };

  const abortControllerRef = useRef(null); // Properly initialized

  useEffect(() => {
    if (!searchValue) {
      // If search is cleared, don't do anything here (handled in onSearchValue)
      return;
    }

    // Cancel previous API call before making a new one
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller; // Correctly assigning controller

    const queryParams = {
      page: 1,
      limit: itemsPerPage,
      sortOrder,
      search: searchValue,
    };

    const noticeTypeFilter = localStorage.getItem("noticeTypeFilter");
    if (noticeTypeFilter) {
      queryParams.noticetypeid = JSON.parse(noticeTypeFilter)?.map((i) => i.id);
    }

    const depotFilter = localStorage.getItem("depotFilter");
    if (depotFilter) {
      queryParams.depotid = JSON.parse(depotFilter)?.map((i) => i.id);
    }

    if (startDate && endDate) {
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }

    // No need for debounce here since input is already debounced
    setPlaceHolder(true);
      dispatch(
        getNoticeList(queryParams, (res) => {
          setPlaceHolder(false);
        }, { signal: controller.signal })
      );
      getTotals();

    return () => {
      if (controller) {
        controller.abort();
      }
    };
  }, [searchValue]);

  const onSearchValue = (value) => {
    // Update input value immediately for responsive UI
    setSearchInputValue(value);
    
    // Debounce the actual search value update (which triggers API calls)
    if (debouncedSetSearchValueRef.current) {
      debouncedSetSearchValueRef.current(value);
    }
    
    // If cleared, update immediately
    if (value === "") {
      if (debouncedSetSearchValueRef.current) {
        debouncedSetSearchValueRef.current.cancel();
      }
      setSearchValue(null);
      setCurrentPage(1);
      
      let queryParams = { page: 1, limit: itemsPerPage, sortOrder: sortOrder };

      const noticeTypeFilter = localStorage.getItem("noticeTypeFilter");
      const noticeTypeFilterObject = noticeTypeFilter ? JSON.parse(noticeTypeFilter) : null;
      if (noticeTypeFilterObject) {
        queryParams.noticetypeid = noticeTypeFilterObject?.map(i => i.id)
      }

      const depotFilter = localStorage.getItem("depotFilter");
      const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
      if (depotFilterObject) {
        queryParams.depotid = depotFilterObject?.map(i => i.id)
      }

      if (startDate && endDate) {
        queryParams.startDate = startDate;
        queryParams.endDate = endDate;
      }

      setPlaceHolder(true);

      dispatch(
        getNoticeList(queryParams, (res) => {
          setPlaceHolder(false);
        })
      );
      getTotals(null); // Explicitly pass null to ensure totals are fetched without search
    }
  }
      
  const searchClearButton = () => {
    setSearchInputValue('');
    setSearchValue(null);
    if (debouncedSetSearchValueRef.current) {
      debouncedSetSearchValueRef.current.cancel();
    }

    // localStorage.removeItem("searchValue")

    let queryParams = { page : 1, limit : itemsPerPage, sortOrder: sortOrder };

    const noticeTypeFilter = localStorage.getItem("noticeTypeFilter");
    const noticeTypeFilterObject = noticeTypeFilter ? JSON.parse(noticeTypeFilter) : null;
    if(noticeTypeFilterObject){
      queryParams.noticetypeid = noticeTypeFilterObject?.map(i => i.id)
    }

    const depotFilter = localStorage.getItem("depotFilter");
    const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
    if(depotFilterObject){
      queryParams.depotid = depotFilterObject?.map(i => i.id)
    }

    if (startDate && endDate){
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }

    setPlaceHolder(true);
    
    dispatch(
      getNoticeList(queryParams, (res) => {
        setPlaceHolder(false); 
      }, (err) => {
        // Error callback - stop loader on API failure
        setPlaceHolder(false);
        console.error('Failed to load notices:', err);
      })
    );
    getTotals(null); // Explicitly pass null to ensure totals are fetched without search

  };
  const handleOverlayClick = () => {
    setIsDatePickerOpen(false);
  };
  console.log('new Date().setHours(0)', new Date())

  const dateFilter = () => {
    return (
      <>
        <div className="calenderWrapper">
          <Calender
            onChange={(date) => {
              handleDateFilterChange(date);
            }}
            showIcon ={startDate ? false : true}
            className='calenderFilterWrapper'
            selectsRange={true}
            startDate={startDate ? new Date(startDate) : null} // Convert ISO string back to Date object for DatePicker
            endDate={endDate ? new Date(endDate) : null}     // Convert ISO string back to Date object for DatePicker
            // CHANGE 2: Remove the 'selected' prop here
            // selected={startDate} // REMOVE THIS LINE
            placeholderText="Select "
            isClearable={true}
            minDate={new Date().setHours(0, 0, 0, 0)}
            monthsShown={2}
            openToDate={startDate ? new Date(startDate) : null} // Keep this if you want to open to the selected start date
            dateFormat="dd/MM/yy"
            error={dateRangeError}
          />
        </div>
        {isDatePickerOpen && <div className="custom-overlay" onClick={handleOverlayClick}></div>}
      </>
    );
  };
  return (
    <>
      <Helmet>
        <title>Notice Management | ScotRail Safety Notice Portal</title>
      </Helmet>
      <NoticeManagementNewComponent
        totalCounts={totalCounts}
        totalCountsLoading={totalsLoading}
        checkNoticeData={checkNoticeData}
        breadcrumbMainTitle={true}
        exportCsvData={exportCsvData}
        // columns={columns}
        noticeData={noticeListState}
        clearSearchButton={clearSearchButton}
        noDataFound={t("NO_DATA_FOUND")}
        noDataTitle={t("NO_NOTICE_FOUND")}
        noDataDesc={t(
          "YOUR_SEARCH_DID_NOT_MATCH_ANY_NOTICES_PLEASE_TRY_SEARCHING_AGAIN"
        )}
        placeHolderShimer={placeHolder || isRequestPending}
        smarttableref={smarttableref}
        loading={loading}
        dimensions={dimensions}
        tableFilterHeight={tableFilterHeight}
        breadcrumbHeight={breadcrumbHeight}
        tabHeaderHeight={tabHeaderHeight}
        headerHeight={headerHeight}
        loaderHtml={loaderHtml}
        tableContainerRef={tableContainerRef}
        itemsPerPage={itemsPerPage}
        documentDownLoadFun={(item) => {
          documentDownLoadFun(item);
        }}
        onRowClick={(item) => {
          onRowClick(item);
        }}
        exportNotice={exportNotice}
        createNotice={createNotice}
        onTableFilterChange={onTableFilterChange}
        searchValue={searchInputValue}
        searchFilterClear={searchFilterClear}
        onFilteredItemsChange={onFilteredItemsChange}

        noticetypemultiarray={noticetypemultiarray}
        // handleNoticeFilterChange={handleNoticeFilterChange}
        // CustomOption={CustomOption}
        noticeTypeFilter={noticeTypeFilter}
        depotTypeFilter={depotTypeFilter}
        onDepotFilteredItemsChange={onDepotFilteredItemsChange}
        dateFilter={dateFilter}

        onSearchValue={onSearchValue}
        searchVal={searchVal}
        searchClearButton={searchClearButton}
        handlePageClick={handlePageClick}
        handleItemsPerPageChange={handleItemsPerPageChange}
        itemsPerPageOptions={itemsPerPageOptions}
        getSortIcon={getSortIcon}
        handleSort={handleSort}
        totalPages={totalPages}
        currentPage={currentPage}
        pagination={pagination}
        customheaderkeys={customheaderkeys}
        sortOrder={sortOrder}
        startDate={startDate}
        endDate={endDate}
      />
    </>
  );
};
export default NoticeManagementNewContainer;